import React from 'react'
import { Link } from 'react-router-dom'
import "./PrivacyPolicy.scss"
import { FaRegEdit } from 'react-icons/fa'
import { CiCircleRemove } from 'react-icons/ci'
export default function PrivacyPolicy() {
  return (
    <div className='p-3'>
       <div className="headerr">
          <div className="stock-filters">
           <Link to="/dashboard/HelpCenter"><button className="stock-filter ">Help</button></Link>
        <Link to="/dashboard/SupportFaqs"><button className="stock-filter ">FAQs</button></Link> 
         <Link to="/dashboard/PrivacyPolicy"><button className="stock-filter actives">Privacy</button></Link>
          <Link to="/dashboard/Request"><button className="stock-filter ">Request</button></Link>
       
          </div>
        
          <div className="search-wrapperr">
            <input
              type="text"
              placeholder="Search by order id"
              className="stock-search"
            />
            <i className="fa-solid fa-magnifying-glass search-icon"></i>
          </div>
        
          <div className="stock-header">
            <div className="stock-actions">
              <Link to="/dashboard/AddNewProductss">
                    <button className="stock-btn blue">Edit Helpnote</button>
              </Link>
        <Link to="/dashboard/AddNewservieses">
         <button className="stock-btn">Add New Helpnote</button>
        </Link>
             
            </div>
          </div>
        </div>
<div className=' d-flex gap-4'>
 <div className=' '>
        <h6>Privacy Policy</h6>
        <div className=' d-flex flex-column '>
    <input type="text" name="" id=""  className='inpuut'/>
        <textarea name="" id="" className=' text-area'></textarea>
          <div className="faq-actions">
                        <button className="edit">Edit<FaRegEdit/></button>
                        <button className="remove">Remove <CiCircleRemove/></button>
                      </div>
        </div>
    
      </div>

           <div className=' '>
        <h6>Privacy Policy</h6>
        <div className=' d-flex flex-column '>
    <input type="text" name="" id=""  className='inpuut'/>
        <textarea name="" id="" className=' text-area'></textarea>
          <div className="faq-actions">
                        <button className="edit">Edit<FaRegEdit/></button>
                        <button className="remove">Remove <CiCircleRemove/></button>
                      </div>
        </div>
    
      </div>

       
</div>
         <div className="settings-info-actionss container">
          <button type="button" className="cancel">CANCEL</button>
          <button type="submit" className="confirm">CONFIRM</button>
        </div>
    </div>
  )
}
